import request from '@/utils/request'

/*
 * 获取单条帮助信息
 * @param params
 * @return promise对象
 */
export function PROS_GET(params) {
  return request({
    url: `/pub/mall/product`,
    method: 'get',
    params
  })
}

/*
 * 获取单个产品详情
 * @params id params
 * @return  promise对象
 */
export function PRO_GET(id, params) {
  return request({
    url: `/pub/mall/product/${id}`,
    method: 'get',
    params
  })
}

/*
 * 获取产品列表对应的品牌列表
 * @params id params
 * @return  promise对象
 */
export function PROS_BRANDS_GET(params) {
  return request({
    url: '/pub/mall/product/brands',
    method: 'get',
    params
  })
}

// MODEL 定义的变量
export const VARS = {
  // 用户类型
  // {
  //   value: '1',
  //   label: '普通'
  // },
  // 是否上架
  IS_SALE: {
    SALE: {
      value: '1',
      label: '上架中'
    },
    UN_SALE: {
      value: '-1',
      label: '下架中'
    }
  },
  // 是否包含SKU
  HAS_SKU: {
    HAS: {
      value: '1',
      label: '包含'
    },
    UN_HAS: {
      value: '-1',
      label: '无'
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/mall/product.js